import { Validators } from '@angular/forms';
import { PHONE_NUMBER_PATTERN } from '../../../../../../../common/constants';
import { ControlProperty } from '../../../../../../../common/models';
import { makeControlRequiredByKeyValidator, mustNotBeBlankValidator } from '../../../../../../../common/utils';
import { DriverIdType } from '../../../../../administration';

export class AllocationViewUliDriverInformationModel {
  frequentDriverId: number = null;
  firstName: string = null;
  lastName: string = null;
  permitNumber: string = null;
  permitType: DriverIdType = null;
  phoneNumber: string = null;
  loanerPhoneId: string = null;
  parkingSpaceId: string = null;
  remainingDrivingTime = 0;
  nextBreakLength = 0;
  signature: string;
  storeFrequentDriver = false;

  constructor(params?: AllocationViewUliDriverInformationModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewUliDriverInformationForm {
  constructor(
    model: AllocationViewUliDriverInformationModel,
    public frequentDriverId: ControlProperty<number> = model.frequentDriverId,
    public firstName: ControlProperty<string> = [model.firstName, [Validators.required, mustNotBeBlankValidator]],
    public lastName: ControlProperty<string> = [model.lastName, [Validators.required, mustNotBeBlankValidator]],
    public permitNumber: ControlProperty<string> = [model.permitNumber, [mustNotBeBlankValidator]],
    public permitType: ControlProperty<DriverIdType> = [
      model.permitType,
      [makeControlRequiredByKeyValidator('permitNumber')],
    ],
    public phoneNumber: ControlProperty<string> = [
      model.phoneNumber,
      [Validators.required, Validators.pattern(PHONE_NUMBER_PATTERN)],
    ],
    public loanerPhoneId: ControlProperty<string> = model.loanerPhoneId,
    public parkingSpaceId: ControlProperty<string> = model.parkingSpaceId,
    public remainingDrivingTime: ControlProperty<number> = model.remainingDrivingTime || null,
    public nextBreakLength: ControlProperty<number> = model.nextBreakLength || null,
  ) {}
}
